import React, { useEffect, useState } from 'react';
import './Banner.css';
import { ApiKey,imageUrl } from '../../Constants/Constants';
import axios from '../Axios';


function Banner() {
    const [movie,setMovie]=useState()
    useEffect(() => {
      axios.get(`/trending/all/week?api_key=${ApiKey}&language=en-US`).then((response)=>{
          setMovie(response.data.results[11])
        console.log(response.data.results[7])  
        
        })
    }, [])
    
    
    return (
        <div 
        style={{backgroundImage: ` url(${movie ? imageUrl+movie.backdrop_path : ""})`}}
        className='banner'>
            <div className='content'>
                <h1 className='titel'>{movie ? movie.title : ""}</h1>
                <div className='baner-buttons'>
                    <button className='button'>Play</button>
                    <button className='button'>My List</button>
                </div>
                <h1 className='discription'>{movie ? movie.overview : ""}</h1>
                <div className="fade-bottom"></div>
            </div>

        </div>
    )
}

export default Banner